<script>
import CampaignCartTotal from "@/components/cartWidgets/campaignCartTotal";
import CampaignCartInfluencers from "@/components/cartWidgets/campaignCartInfluencers";
import CampaignCartItem from "@/helpers/cart/CampaignCartItem";

export default {
  components: {CampaignCartInfluencers, CampaignCartTotal},
  props: {
    campaignCartItem: {
      type: CampaignCartItem,
      required: true,
    },

  },
  data() {
    return {
      rows: [],
      showInfluencers: true,
    }
  },
  computed: {
    influencerCartItemsArray() {
      return Object.values(this.campaignCartItem.influencerCartItems)
    }
  },
  methods: {
    changeInfluencerVisibility(newValue) {
      this.showInfluencers = newValue;
    },
    updateAmount(influencerId, pricePackageId, newAmount) {
      this.$store.commit('cart/CHANGE_PRICE_PACKAGE_AMOUNT', {
        campaignId: this.campaignCartItem.campaignId,
        influencerId: influencerId,
        pricePackageId: pricePackageId,
        newAmount: newAmount
      })
    },
    removePricePackageFromState(influencerId, pricePackageId) {
      this.$store.commit('cart/REMOVE_PRICE_PACKAGE', {
        campaignId: this.campaignCartItem.campaignId,
        influencerId: influencerId,
        pricePackageId: pricePackageId,
      })

    },
    downloadCartPreview() {
      this.$refs.campaignCartInfluencersRef.downloadCartPreview(this.campaignCartItem);
    }
  },
}
</script>

<template>
  <div class="pb-1">
    <div class="card" v-if="influencerCartItemsArray.length>0">
      <div class="card-header" style="background: #f6f6f6">
        <div class="row">
          <div class="col-12 mb-0 font-size-11 text-muted">
            Campaign
          </div>
          <div class="col-12 d-flex justify-content-between mb-3">
            <h4 class="mb-0">{{ campaignCartItem.campaignInternalName }}</h4>
            <a class="btn btn-info btn-sm text-nowrap"
               @click="downloadCartPreview()">
              <i class="mr-1 fas fa-download"
                 style="vertical-align: middle; font-size:1.35em;"></i>Download
            </a>
<!--            <a class="btn btn-outline-info btn-sm text-nowrap"-->
<!--               @click="showInfluencers = !showInfluencers;">-->
<!--              <i class="mr-1 fas fa-chevron-left"-->
<!--                 :class="{'rotating-arrow': showInfluencers, 'rotating-arrow-reverse': !showInfluencers}"-->
<!--                 style="vertical-align: middle; font-size:1.35em;"></i>Influencers-->
<!--            </a>-->
          </div>
        </div>
        <campaign-cart-total :campaignCartItem="campaignCartItem"></campaign-cart-total>

      </div>
      <div :class="{'card-body': false}" class="px-3 pt-0">

        <b-collapse id="collapse-prices" v-model="showInfluencers">
          <div class="row">
            <div class="col-md-12">
              <campaign-cart-influencers ref="campaignCartInfluencersRef" :influencerCartItems="influencerCartItemsArray" @amountChanged="updateAmount" @pricePackageRemoved="removePricePackageFromState"></campaign-cart-influencers>
            </div>
          </div>
        </b-collapse>
      </div>

    </div>
  </div>

</template>

<style scoped>

.rotating-arrow {
  transition: 0.10s all;
  transform: rotate(-90deg);
}

.rotating-arrow-reverse {
  transition: 0.10s all;
}
</style>

